import React from "react";
import { Routes, Route } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Home from './pages/Home';
import UsPage from "./pages/UsPage";
import CanalizacionesPage from "./pages/CanalizacionesPage";
import MusicPage from "./pages/MusicPage";
import Contact from "./pages/ContactPage";
import ChannelingDetailPage from "./pages/ChannelingDetailPage";
import AdminPage from "./pages/AdminPage";
import ScrollToTop from "./components/ScrollToTop";

const Router = ({ childProps }) => {
  const { t } = useTranslation();
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home {...childProps} />} />

        <Route path="/nosotros" element={<UsPage {...childProps} />} />

        <Route path="/trabajadores-de-la-luz" element={<CanalizacionesPage {...childProps} section={"trabajadores-de-la-luz"} title={t('section.tdl')} />} />

        <Route path="/esenios-abuela-ana" element={<CanalizacionesPage {...childProps} section={"esenios-abuela-ana"} title={t('section.abuela')} />} />
        <Route path="/esenios-maria-magdalena" element={<CanalizacionesPage {...childProps} section={"esenios-maria-magdalena"} title={t('section.magdalena')} />} />
        <Route path="/esenios-maria-madre" element={<CanalizacionesPage {...childProps} section={"esenios-maria-madre"} title={t('section.madre')} />} />
        <Route path="/esenios-jeshua" element={<CanalizacionesPage {...childProps} section={"esenios-jeshua"} title={t('section.jeshua')} />} />

        <Route path="/angeles-y-arcangeles/zadquiel" element={<CanalizacionesPage {...childProps} section={"angeles-y-arcangeles/zadquiel"} title={t('section.zadquiel')} />} />
        <Route path="/angeles-y-arcangeles/uriel" element={<CanalizacionesPage {...childProps} section={"angeles-y-arcangeles/uriel"} title={t('section.uriel')} />} />
        <Route path="/angeles-y-arcangeles/jofiel" element={<CanalizacionesPage {...childProps} section={"angeles-y-arcangeles/jofiel"} title={t('section.jofiel')} />} />
        <Route path="/angeles-y-arcangeles/chamuel" element={<CanalizacionesPage {...childProps} section={"angeles-y-arcangeles/chamuel"} title={t('section.chamuel')} />} />
        <Route path="/angeles-y-arcangeles/rafael" element={<CanalizacionesPage {...childProps} section={"angeles-y-arcangeles/rafael"} title={t('section.rafael')} />} />
        <Route path="/angeles-y-arcangeles/gabriel" element={<CanalizacionesPage {...childProps} section={"angeles-y-arcangeles/gabriel"} title={t('section.gabriel')} />} />
        <Route path="/angeles-y-arcangeles/metatron" element={<CanalizacionesPage {...childProps} section={"angeles-y-arcangeles/metatron"} title={t('section.metatron')} />} />
        <Route path="/angeles-y-arcangeles/miguel" element={<CanalizacionesPage {...childProps} section={"angeles-y-arcangeles/miguel"} title={t('section.miguel')} />} />
        <Route path="/angeles-y-arcangeles/angeles" element={<CanalizacionesPage {...childProps} section={"angeles-y-arcangeles/angeles"} title={t('section.angeles')} />} />

        <Route path="/gaia" element={<CanalizacionesPage {...childProps} section={"gaia"} title={"Gaia"} />} />
        
        <Route path="/musica-mom" element={<MusicPage {...childProps} playlistId={"6tMCcn6SC9VOYeDBO8eqwf"} title="MOM" />} />
        <Route path="/musica-mantras" element={<MusicPage {...childProps} playlistId={"14qnv1ZxAzjUYSVDEU6R10"} title="MANTRAS" />} />
        <Route path="/musica-meditation" element={<MusicPage {...childProps} playlistId={"6WYXMM1sLOg3ObpbL6Fl5S"} title="MEDITATIONS" />} />

        <Route path="/contacto" element={<Contact {...childProps} />} />

        <Route path="/canalizacion/:id" element={<ChannelingDetailPage />} />

        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </>
  );
};

export default Router;